import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  aptosPagamentos: [],
  contaPagamento: {},
  retencoesLiquidacao: [],
  total: {},
  filtros: []
});

function AptoPagamentoReducer(state = initialState, action) {
  switch (action.type) {
    case types.APTOS_PAGAMENTOS_START:
    case types.APTOS_PAGAMENTOS_TOTAL_START:
    case types.CONTA_PAGAMENTO_START:
    case types.RETENCOES_LIQUIDACAO_START: {
      return startLoad(state);
    }

    case types.APTOS_PAGAMENTOS_ERROR:
    case types.APTOS_PAGAMENTOS_TOTAL_ERROR:
    case types.CONTA_PAGAMENTO_ERROR:
    case types.RETENCOES_LIQUIDACAO_ERROR: {
      return endLoad(state);
    }

    case types.APTOS_PAGAMENTOS_SUCCESS: {
      return endLoad(state.set('aptosPagamentos', fromJS(action.payload)));
    }
    case types.APTOS_PAGAMENTOS_TOTAL_SUCCESS: {
      return endLoad(state.set('total', fromJS(action.payload)));
    }
    case types.CONTA_PAGAMENTO_SUCCESS: {
      return endLoad(state.set('contaPagamento', fromJS(action.payload)));
    }
    case types.RETENCOES_LIQUIDACAO_SUCCESS: {
      return endLoad(state.set('retencoesLiquidacao', fromJS(action.payload)));
    }
  }
  return state;
}

export default AptoPagamentoReducer;
